import { PACK_WEIGHT } from "../utils/offerUpsells";
import Upsells from "../Upsells";

// Same screen as Upsells but on the weight-2 (packs) offer plans — this is
// the last optional-coverage step, so it owns the subscription creation.
const Packs = (props) => <Upsells {...props} weight={PACK_WEIGHT} />;

export default Packs;
